import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./axiosConfig"; 
import { CheckCircle2, Home, Package, Sparkles } from "lucide-react";

export default function CommandeEnvoyee() {
  const navigate = useNavigate();
  const [sponsorLogo, setSponsorLogo] = useState(null);

  useEffect(() => {
    api.get("/platform/sponsor")
      .then(res => {
        if (res.data.sponsorLogo) {
          setSponsorLogo(res.data.sponsorLogo);
        }
      })
      .catch(err => console.error("Sponsor ignoré :", err));
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen px-6 pb-12 font-sans pt-28 bg-[#FAFAFA]">
      <div className="relative w-full max-w-lg p-12 text-center bg-white border border-gray-100 shadow-2xl rounded-[3rem] animate-fade-up">
        
        {/* Éléments décoratifs en arrière-plan */}
        <div className="absolute top-0 w-32 h-32 -translate-x-1/2 -translate-y-1/2 rounded-full left-1/2 bg-green-50 blur-3xl opacity-60"></div>
        
        {/* Badge de Succès Animé */}
        <div className="relative mb-8">
            <div className="absolute inset-0 scale-150 bg-green-100 rounded-full opacity-20 animate-ping"></div>
            <div className="relative flex items-center justify-center w-24 h-24 mx-auto bg-green-500 rounded-full shadow-lg shadow-green-200">
                <CheckCircle2 size={48} className="text-white" />
            </div>
            <Sparkles className="absolute top-0 text-yellow-400 right-1/4 animate-bounce" size={24} />
        </div>

        {/* Texte de confirmation mis à jour */}
        <div className="mb-6 space-y-3">
            <h1 className="text-4xl font-black tracking-tight text-slate-900">
                C'est <span className="text-green-500">validé !</span>
            </h1>
            <p className="text-lg font-medium leading-relaxed text-slate-500">
                Votre commande a été transmise. <br /> 
                <span className="font-bold text-slate-700">Un livreur vous contactera par téléphone pour la remise de votre colis.</span>
            </p>
        </div>

        {/* ✅ LOGO SPONSOR AGRANDI */}
        {sponsorLogo && (
          <div className="flex flex-col items-center mb-10 animate-fade-in">
            <div className="w-16 h-px bg-gray-100 mb-6"></div>
            <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-gray-400 mb-4">
              Partenaire officiel
            </span>
            <img 
              src={sponsorLogo} 
              alt="Sponsor" 
              className="h-20 w-auto max-w-[220px] object-contain transition-transform duration-300 hover:scale-105" 
            />
          </div>
        )}

        {/* Rappel du processus */}
        <div className="flex items-center gap-4 p-4 mb-10 text-left border bg-slate-50 rounded-2xl border-slate-100">
            <div className="flex-shrink-0 w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-sm text-[#f34141]">
                <Package size={20} />
            </div>
            <div>
                <p className="text-xs font-black uppercase tracking-widest text-slate-400 mb-0.5">Statut actuel</p>
                <p className="text-sm font-bold text-slate-700">Préparation de votre colis...</p>
            </div>
        </div>

        {/* Actions de navigation */}
        <div className="grid gap-4 sm:grid-cols-2 mb-12">
          <button
            onClick={() => navigate("/commandes")}
            className="flex items-center justify-center gap-2 bg-[#1e293b] text-white py-5 px-6 rounded-2xl font-black shadow-xl shadow-slate-200 hover:bg-[#334155] transition-all duration-300 active:scale-95"
          >
            <Package size={20} />
            Suivre l'état
          </button>

          <button
            onClick={() => navigate("/")}
            className="flex items-center justify-center gap-2 px-6 py-5 font-bold transition-all duration-300 bg-gray-100 text-slate-600 rounded-2xl hover:bg-gray-200 active:scale-95"
          >
            <Home size={20} />
            Accueil
          </button>
        </div>

        {/* FOOTER : Souqi Signature */}
        <div className="pt-8 border-t border-gray-50">
            <p className="text-sm font-black uppercase tracking-[0.15em] bg-clip-text text-transparent bg-gradient-to-r from-[#f34141] to-[#ff8e8e]">
                Merci d'avoir choisi Souqi
            </p>
        </div>
      </div>
    </div>
  );
}
